
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ideas",
      function () {
        return require("private-next-pages/ideas.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ideas"])
      });
    }
  